export default __webpack_public_path__ + "static/media/empowerment.549d49ec.png";